import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-dados-renajud',
  templateUrl: './consulta-dados-renajud.component.html',
  styleUrls: ['./consulta-dados-renajud.component.scss']
})
export class ConsultaDadosRenajudComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msg = "";

  descricaoStatusConsulta = "info";
  possuiInformacaoRenajud: boolean;

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.setStatus();
    this.getInformacaoRenajudCheckList();
  }

  getInformacaoRenajudCheckList() {
    this.possuiInformacaoRenajud = false;
    if( this.consulta && this.consulta.listaRestricaoJudicial &&  this.consulta.listaRestricaoJudicial.length != 0){
      for (var i = 0; i < this.consulta.listaRestricaoJudicial.length; i++) {
        if(this.consulta.listaRestricaoJudicial[i] && (this.consulta.listaRestricaoJudicial[i].tipoRestricao || this.consulta.listaRestricaoJudicial[i].situacaoJudicial != "NADA CONSTA" )){
          this.possuiInformacaoRenajud = true;
        }else {
          this.statusMsg = "NADA CONSTA";
          this.status = "success";
        }
      }
    }else {
      this.statusMsg = "NADA CONSTA";
      this.status = "success";
    }
  }

  setStatus() {
    if (this.consulta) {
      if (this.consulta.listaRestricaoJudicial) {
        for (var i = 0; i < this.consulta.listaRestricaoJudicial.length; i++) {
          if (this.consulta.listaRestricaoJudicial[i] && (this.consulta.listaRestricaoJudicial[i].tipoRestricao || this.consulta.listaRestricaoJudicial[i].situacaoJudicial != "NADA CONSTA")) {
            this.statusMsg = "VEÍCULO COM DETALHAMENTO DE PROCESSO RENAJUD";
            this.status = "danger";
          }
        }
      } else {
        this.statusMsg = "NADA CONSTA";
        this.status = "success";
      }
    }
  }

}
